import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Search } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";
import { blogListPath } from "@/lib/blog";

export function SearchBar({ lang, initialValue = "" }) {
  const { t } = useLanguage();
  const navigate = useNavigate();
  const [value, setValue] = useState(initialValue);

  const submit = (e) => {
    e.preventDefault();
    const q = value.trim();
    if (!q) return;
    navigate(`${blogListPath(lang)}?search=${encodeURIComponent(q)}`);
  };

  return (
    <form onSubmit={submit} className="relative">
      <Search className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-slate-400 pointer-events-none" />
      <input
        type="search"
        value={value}
        onChange={(e) => setValue(e.target.value)}
        placeholder={t("blog.searchPlaceholder")}
        className="w-full pl-12 pr-28 py-3.5 bg-white border border-slate-200 rounded-full text-sm text-slate-900 placeholder-slate-400 focus:outline-none focus:border-[#22A7D1] focus:ring-2 focus:ring-sky-100 transition-all shadow-sm hover:shadow-md"
      />
      <button
        type="submit"
        className="absolute right-1.5 top-1/2 -translate-y-1/2 px-5 py-2.5 text-sm font-semibold text-white rounded-full bg-[#22A7D1] hover:bg-[#1B8FB5] transition-all hover:shadow-md"
      >
        {t("blog.searchButton")}
      </button>
    </form>
  );
}
